export default __webpack_public_path__ + "static/media/gallery-wip-bunny-ears_02.e56c4c74.jpg";